<template>
<b-row>
	<b-col cols="12" class="pt-3">
	<template v-if="clusterIds.length === 0">
        <p>Waiting for data ...</p>
    </template>
    <template v-else>
    	 <b-col>
       
        <div class="row">
            <!--<ActivityInfo :information="information"></ActivityInfo>-->
        </div>
         </b-col >
        <template v-for="clusterId in clusterIds">
            <b-col cols="12">
            
            <div class="OTcluster"  v-bind:class="{'OTcluster-error': hasComponentError(clusterId)}">
                <h3 class="OTclusterName"><span class="ot-icon-notification"></span>{{clusters[clusterId].name}} ( {{clusters[clusterId].components.length}} components ) <span class="OTiconClusterError" v-if="hasComponentError(clusterId)"></span></h3>
                <CrawlerTable v-if="clusters[clusterId].name === 'local-documents' || clusters[clusterId].name === 'wsm-crawler' || clusters[clusterId].name === 'ecm-crawler'" :clusterId="clusterId"></CrawlerTable>
                <PipelineTable v-else-if="clusters[clusterId].name === 'pipeline'" :clusterId="clusterId"></PipelineTable>
                <EcmAnnotatorTable v-else-if="clusters[clusterId].name === 'ecm-annotator'" :clusterId="clusterId"></EcmAnnotatorTable>
                <GenericTable :clusterId="clusterId" v-else></GenericTable>
            </div>
            </b-col>
        </template>
    </template>
    </b-col>
</b-row>
</template>

<script>

import CrawlerTable from './activityTables/crawler/CrawlerTable.vue';
import EcmAnnotatorTable from './activityTables/ecmAnnotator/EcmAnnotatorTable.vue';
import PipelineTable from './activityTables/pipeline/PipelineTable.vue';
import GenericTable from './GenericTable.vue';
import ActivityInfo from './ActivityInfo.vue';
import PageIntro from './PageIntro.vue';

export default {
    computed: {
        clusterIds() {
            return this.$store.state.components.clusterIds;
        },

        clusters() {
            return this.$store.state.components.clusters;
        },

        information(){
            return "Activity Information"
        },

        hasComponentError() {
            return function(clusterId) {
                var errors = this.$store.state.components.clusters[clusterId].components.filter((id) => {
                    const component = this.$store.state.components.components[id];

                    if (component) {
                        if (component.hasOwnProperty('status')) {
                            if (component['status'] === 'not running') {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                });

                return (errors.length > 0);
            }
        }
    },

    components: {
        CrawlerTable,
        EcmAnnotatorTable,
        PipelineTable,
        GenericTable,
        ActivityInfo,
        PageIntro
    }
}
</script>
